import About from './About/About.js';
import Experience from './Experience/Experience.js';
import Projects from './Projects/Projects.js';
import './MainContent.css';

function MainContent({getMediaList}) {
  return (
    <div className="main-content">
      <About />

      <Experience />

      <Projects getMediaList={getMediaList}/>

      <div className="footer">
        I designed a UI in Figma and implemented it in Visual Studio Code using <b>React.js</b> and <b>CSS</b>. Set up the backend with <b>Node.js Express</b> on <b>AWS Lambda</b>, integrating <b>DynamoDB</b> for NoSQL. Established a <b>RESTful API</b> with <b>API Gateways</b>. Deployed it via <b>AWS Amplify</b>, using an <b>S3 bucket</b> for data storage.
      </div>
    </div>
  )
}

export default MainContent;